import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Layout from "./Layout.jsx";
import Home from "./Components/Home/Home.jsx";
import Company from "./Components/Company/Company.jsx";
import Career from "./Components/Career/Career.jsx";
import JobDetail from "./Components/Career/JobDetail.jsx";
import ApplyPage from "./Components/Career/ApplyPage.jsx";
import Blog from "./Components/Blog/Blog.jsx";
import MicrosoftCopilotBlog from "./Components/Blog/BlogPages/MicrosoftCopilotBlog/MicrosoftCopilotBlog.jsx";
import RaaSBlog from "./Components/Blog/BlogPages/ResourceAsService/RaaSBlog.jsx";
import MicrosoftPowerPlatform from "./Components/Blog/BlogPages/MicrosoftPowerPlatform/MicrosoftPowerPlatform.jsx";
import AzureBenefit from "./Components/Blog/BlogPages/AzureBenefits2025/AzureBenefit.jsx";
import Microsoft365 from "./Components/Blog/BlogPages/Microsoft365/Microsoft365.jsx";
import MicrosoftSharePoint from "./Components/Blog/BlogPages/MicrosoftSharePoint/MicrosoftSharePoint.jsx";
import MicrosoftTeamsPhone from "./Components/Blog/BlogPages/MicrosoftTeamsPhone/MicrosoftTeamsPhone.jsx";
import MicrosoftDefender from "./Components/Blog/BlogPages/MicrosoftDefender/MicrosoftDefender.jsx";
import Microsoft365forIndianBusinesses from "./Components/Blog/BlogPages/Microsoft365forIndianBusinesses/Microsoft365forIndianBusinesses.jsx";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      {/* <Route path='company' element={<Company />} /> */}
      <Route path="/career" element={<Career />} />
      <Route path="/job/:id" element={<JobDetail />} />
      <Route path="/apply/:id" element={<ApplyPage />} />
      <Route path="/blog" element={<Blog />} />
      <Route
        path="/blog/how-microsoft-copilot-is-transforming-business-productivity"
        element={<MicrosoftCopilotBlog />}
      />
      <Route
        path="/blog/raas-benefits-for-growing-companies"
        element={<RaaSBlog />}
      />
      <Route
        path="blog/microsoft-power-platform-future-low-code-business-solutions"
        element={<MicrosoftPowerPlatform />}
      />
      <Route
        path="/blog/why-enterprises-are-moving-to-microsoft-azure-2025"
        element={<AzureBenefit />}
      />
      <Route
        path="/blog/microsoft-365-benefits-for-business"
        element={<Microsoft365 />}
      />
      <Route
        path="/blog/microsoft-sharepoint-benefits-for-business"
        element={<MicrosoftSharePoint />}
      />
      <Route
        path="/blog/microsoft-teams-phone-system-benefits-for-business"
        element={<MicrosoftTeamsPhone />}
      />
      <Route
        path="/blog/why-microsoft-defender-for-endpoint-is-essential-for-business-security"
        element={<MicrosoftDefender />}
      />
      <Route
        path="/blog/microsoft-365-for-indian-businesses"
        element={<Microsoft365forIndianBusinesses />}
      />
    </Route>
  )
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <App /> */}
  </React.StrictMode>
);
